import React, { FormEvent, useState } from 'react';
import axios, { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import Logo from '../../public/images/logo.svg';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [resetLinkSent, setResetLinkSent] = useState(false);

  const openCrispChat = () => {
    if (window.$crisp) {
      window.$crisp.push(['do', 'chat:open']);
      window.$crisp.push(["set", "message:text", ["I need help resetting my password "]]);
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    try {
      await axios.post('/api/auth/forgot-password', { email });
      setResetLinkSent(true);
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const errorMessage = error.response.data?.message || 'Reset failed. Please try again.';
          toast.warning(errorMessage, { position: 'top-center' });
        } else if (error.request) {
          // The request was made but no response was received
          toast.warning('No response received from the server. Please try again later.');
        } else {
          // Something happened in setting up the request that triggered an Error
          toast.warning('Error occurred while setting up the request.');
        }
      } else {
        toast.error('An unknown error occurred.');
        throw new Error('An unknown error occurred.');
      }
    }
  };

  if (resetLinkSent) {
    return (
      <div className='flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8'>
        <div className='sm:mx-auto sm:w-full sm:max-w-md'>
          <img
            className='mx-auto h-10 w-auto'
            src={Logo}
            alt='Neoface Logo'
          />
          <h2 className='mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900'>
            Reset Your Password
          </h2>
          <p className='mt-4 text-center text-base text-gray-600'>
            If this email exists in our system, we've sent a password reset link to {email}. Please check your email and follow the instructions to reset
            your password.
          </p>
          <p className='mt-2 text-center text-sm text-gray-600'>
            <b>If you don't see our email, please check your spam folder or</b> <a href='#' onClick={openCrispChat} className='font-medium text-indigo-600 hover:text-indigo-500'>contact support</a>.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className='flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8 px-4'>
        <div className='sm:mx-auto sm:w-full sm:max-w-md'>
          <img
            className='mx-auto h-10 w-auto'
            src={Logo}
            alt='Neoface Logo'
          />
          <h2 className='mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900'>
            Forgot Password
          </h2>
        </div>
        <div className='mt-10 mx-auto max-w-[480px] sm:w-full'>
          <div className='bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12'>
            <form className='space-y-6' onSubmit={handleSubmit}>
              <div>
                <label htmlFor='email' className='block text-sm font-medium leading-6 text-gray-900'>
                Email address
                </label>
                <div className='mt-2'>
                  <input
                    id='email'
                    name='email'
                    type='email'
                    autoComplete='email'
                    required
                    className='block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <div>
                <button
                  type='submit'
                  className='flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                >
                  Send Password Reset Link
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}